import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {StoreUtils} from '../utils/store-utils';

@Injectable({
  providedIn: 'root'
})
export class StoreIdService {

  private subject = new Subject<any>();

  onStoreIdChange(storeName: string, storeId: string, isSummaryStore?: boolean) {
    const href = window.location.href.split('/');
    if(href.includes('versita-stores')
      || href.includes('request-demo')
      || href.includes('import')
      || href.includes('about-contact-us')
      || href.includes('item-special')
      || href.includes('signup')
      || href.includes('review')
      || href.includes('home-page')
    )
      StoreUtils.setSelectStoreId(storeId);

    this.subject.next({ storeName: storeName, storeId: storeId, isSummaryStore: isSummaryStore});
  }

  onGetStoreId(): Observable<any> {
    return this.subject.asObservable();
  }
}
